import { RouteComponentProps } from '@reach/router';

import { BreadcrumbLink } from 'components/breadcrumb/BreadcrumbLink';
import { BreadcrumbSeparator } from 'components/breadcrumb/BreadcrumbSeparator';
import { tNamespaced } from 'utils/i18nUtil';
import RouteConstants from 'utils/RouteConstants';

export const webhookCustomSynapseItemPath = '/developer-studio/custom-synapses/webhook/:id';
export const httpCustomSynapseItemPath = '/developer-studio/custom-synapses/http/:id';
export const sdkCustomSynapseItemPath = '/developer-studio/custom-synapses/sdk/:id';
export const entitiesBasePath = '/developer-studio/custom-synapses/http/:synapseId/entities/:version/*';
export const entitiesItemPath = '/developer-studio/custom-synapses/http/:synapseId/entities/:version/:entityId';

const tn = tNamespaced('DeveloperStudio');

export const CustomSynapseBreadcrumb = (props: RouteComponentProps) => {
  return (
    <>
      <BreadcrumbSeparator />
      <BreadcrumbLink to={RouteConstants.DEVELOPER_STUDIO_CUSTOM_SYNAPSES}>{tn('custom_synapses')}</BreadcrumbLink>
    </>
  );
};
